// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__a5ee0"};